var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-input',{attrs:{"value":_vm.hostName,"placeholder":_vm.isWindows ? _vm.$t('compute.validate.windows') : _vm.$t('compute.validate.others')},on:{"change":_vm.handleHostNameChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }